import React, { createRef, Fragment, useCallback, useEffect, useState } from 'react'
import { Row, Col } from 'reactstrap'
import { theme } from '../../theme'

const defaultFile = { preview: '', raw: '' }

const File = ({ onFileChange, isLoading, clean }) => {
  const [file, setFile] = useState(defaultFile)

  let inputRef = createRef()

  const handleFileChange = useCallback(
    (e) => {
      if (e.target.files.length) {
        const selected = {
          preview: URL.createObjectURL(e.target.files[0]),
          raw: e.target.files[0],
        }

        setFile(selected)
        onFileChange(selected)
      }
    },
    [onFileChange]
  )

  const handleRemoveFile = useCallback(() => {
    setFile(defaultFile)
    onFileChange(defaultFile)
    if (inputRef) {
      inputRef.value = null
    }
  }, [inputRef, onFileChange])

  const inputKey = inputRef.value ? inputRef.value.name : +new Date()

  useEffect(() => {
    if (clean) {
      handleRemoveFile()
    }
  }, [clean, handleRemoveFile])

  return (
    <Fragment>
      <label htmlFor="file-input">
        <span
          style={{
            cursor: 'pointer',
            display: 'block',
            letterSpacing: 2,
            borderRadius: 20,
            fontWeight: 400,
            borderWidth: 0,
            textTransform: 'none',
            fontSize: 12,
            lineHeight: 1.5,
            backgroundColor: theme.colors.secondary,
            color: '#ffffff',
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 55,
            paddingLeft: 55,
          }}
        >
          <strong>Selecionar</strong> Planilha
        </span>
      </label>
      <input
        key={inputKey}
        ref={(el) => (inputRef = el)}
        disabled={isLoading}
        type="file"
        id="file-input"
        name="file-input"
        style={{ display: 'none' }}
        onChange={handleFileChange}
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      />

      {file?.raw && (
        <Row style={{ padding: '5px 20px 0 20px' }}>
          <Col style={{ flex: 1 }}>{file.raw.name}</Col>
          {!isLoading && (
            <a href="#!" style={{ color: 'red', fontWeight: 'bold' }} onClick={handleRemoveFile}>
              X
            </a>
          )}
        </Row>
      )}
    </Fragment>
  )
}

export default File
